import ColorfulDivider from './colorful-divider';
export default ColorfulDivider;
